import { render } from "./DatasetTile.vue?vue&type=template&id=23ea2b69&scoped=true"
import script from "./DatasetTile.vue?vue&type=script&lang=ts"
export * from "./DatasetTile.vue?vue&type=script&lang=ts"

import "./DatasetTile.vue?vue&type=style&index=0&id=23ea2b69&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-23ea2b69"

export default script